import axios, { AxiosInstance } from 'axios';
import { defaultRequestInterceptorFail, defaultRequestInterceptorSuccess, defaultResponseInterceptorFail, defaultResponseInterceptorSuccess } from '../axiosInterceptors';
import { fetchAppConfig } from '../../common/configUtil';
import { IAppConfigType } from '../../models/appConfig.model';

let axiosPortalInstance: AxiosInstance = axios.create();
const initialiseAxios = async (type: IAppConfigType = IAppConfigType.PROD, reload: boolean = false) => {
  try {
    try {
      axiosPortalInstance.interceptors.request.clear();
      axiosPortalInstance.interceptors.response.clear();
    } catch {}

    axiosPortalInstance.defaults.baseURL = (await fetchAppConfig(type, reload)).portalUrl;

    axiosPortalInstance.interceptors.request.use(defaultRequestInterceptorSuccess, defaultRequestInterceptorFail);
    axiosPortalInstance.interceptors.response.use(defaultResponseInterceptorSuccess, defaultResponseInterceptorFail);
  } catch (error) {
    console.error('Error setting up axios:', error);
    throw error;
  }
};

// Initialize axiosPortalInstance asynchronously
initialiseAxios().catch((error) => {
  console.error('Error initializing axiosPortalInstance:', error);
});

export const reInitialisePortalAxios = async (type: IAppConfigType) => {
  await initialiseAxios(type, true);
};

export default axiosPortalInstance;
